import { GetWeightedExpressionParams } from './getWeightedExpression.types';

const getWeightedExpression = (params: GetWeightedExpressionParams): string => {
  const { allComparisonsExpression, allWeightingExpression, isSingleComparison } = params;

  if (isSingleComparison) {
    return `SUM(FILTER_VALID([${allComparisonsExpression}]))`;
  }

  return `SUMPRODUCT(FILTER_VALID([${allComparisonsExpression}]), FILTER_VALID([${allWeightingExpression}]))`;
};

export default getWeightedExpression;
